import { useEffect } from 'react';
import { AnalyticsEvent, analyticsService } from '~/services/analytics';
import {
  checkoutStore,
  mainStore,
  orderStore,
  settingStore,
  userStore,
} from '~/stores';
import { favoritesStore } from '~/stores/FavoritesStore/FavoritesStore';

import {
  ANALYTICS_PRODUCTS_SHOWN_INTERVAL,
  REQUEST_ETA_INTERVAL,
} from '../stores/constants';
import { listenerOnResize } from '../UI';

export const useRequestCycle = () => {
  useEffect(() => {
    listenerOnResize();
    if (!userStore.deliveryAddress?.coordinates) {
      userStore.setDeliveryAddress(null);
    }
    orderStore.requestCurrency();
    settingStore.requestSettings();
    if (userStore.isAuthorized) {
      userStore
        .requestPersonalData()
        .catch((error) => error && console.error(error));
      userStore.loyaltyPointsStore
        .requestTerms()
        .catch((error) => error && console.error(error));
    } else {
      userStore.resetCustomerType();
    }
    mainStore.setSentryUser({
      id: userStore.personalData.id || '',
      name: userStore.fullName,
      email: userStore.personalData.email || '',
      phone: userStore.personalData.phone || '',
    });
    setInterval(() => {
      if (mainStore.inBackground) {
        return;
      }
      analyticsService.flush(AnalyticsEvent.CATALOG_PRODUCT_SNIPPET_SHOWN);
    }, ANALYTICS_PRODUCTS_SHOWN_INTERVAL);

    if (!userStore.deviceId && !mainStore.isRN) {
      userStore.setDeviceId('00000000-0000-0000-0000-000000000000');
    }
  }, []);

  useEffect(() => {
    orderStore.requestETA();
    const interval = setInterval(() => {
      if (!orderStore.etaCalculation || mainStore.inBackground) {
        return;
      }
      orderStore.requestETA();
    }, REQUEST_ETA_INTERVAL);
    return () => clearInterval(interval);
  }, [userStore.isFirstLaunch]);

  useEffect(() => {
    if (!userStore.isAuthorized) {
      return;
    }
    favoritesStore.fetchFavoritesIds();
  }, [userStore.isAuthorized]);

  useEffect(() => {
    if (mainStore.isRN && !mainStore.appVersion) {
      return;
    }

    if (!userStore.isAuthorized) {
      return;
    }
    const deliveryZoneId =
      orderStore.etaCalculation?.warehouse.zone[checkoutStore.deliveryMethod]
        ?.id;

    orderStore.requestPaymentSystems(deliveryZoneId).then(() => {
      orderStore.requestPayments(deliveryZoneId);
    });
  }, [
    userStore.isAuthorized,
    mainStore.appVersion,
    mainStore.isRN,
    orderStore.etaCalculation?.warehouse.zone[checkoutStore.deliveryMethod]?.id,
    checkoutStore.deliveryMethod,
  ]);
};
